import React from 'react'
import { SmartVisibleChild } from '@mtsdengi/common'
import { DesktopPremiumTab, MobilePremiumTab } from '@entities'

export const Requirements = ({ requirements }) => (
  <>
    <SmartVisibleChild conditions={{ none: 'none', tablet: 'block' }}>
      <DesktopPremiumTab {...requirements} />
    </SmartVisibleChild>
    <SmartVisibleChild conditions={{ none: 'block', tablet: 'none' }}>
      <MobilePremiumTab {...requirements} />
    </SmartVisibleChild>
  </>
)
